(function ($) {
	$(document).ready(function () {
		$('.button[disabled]').click(function (e) {
			e.preventDefault();
			return false;
		});

		// copy content to clipboard on click
		$('.button[data-clipboard]').click(function (e) {
			e.preventDefault();
			$(this).html('Copied!');
			const text = $(this).data('clipboard');
			const el = document.createElement('textarea');
			el.value = text;
			document.body.appendChild(el);
			el.select();
			document.execCommand('copy');
			document.body.removeChild(el);

			const t = $(this);
			setTimeout(function () {
				t.html('Copy');
			}, 2000);
		});
	});
})(jQuery);
